import React from 'react';
import styled from 'styled-components';
import {DARK_MODE_TEXT_COLOR, LIGHT_MODE_TEXT_COLOR} from "../../constants/colorScheme";

const SideMenuContainer = styled.div`
    .side-menu-logo {
        display: block;
        margin: 0 auto; 
    }
    .ant-layout-sider-children {
        padding-top: 15px;
    }
    .ant-menu {
        padding-top: 30px;
    }
    .logo-wrapper {
        cursor: pointer;
    }
    
    .ant-divider-inner-text {
        color: ${props => props.darkMode ? DARK_MODE_TEXT_COLOR : LIGHT_MODE_TEXT_COLOR }
    }
`;

export default SideMenuContainer;